import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ja from './locales/ja.json';
import en from './locales/en.json';

const detectLngFromPathname = (pathname) => {
  const m = String(pathname || '').match(/^\/(ja|en)(\/|$)/);
  return m ? m[1] : null;
};

const detectInitialLng = () => {
  const fromPath = detectLngFromPathname(window.location.pathname);
  if (fromPath) return fromPath;
  const nav = String(navigator.language || navigator.userLanguage || '').toLowerCase();
  if (nav.startsWith('ja')) return 'ja';
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
    en: { translation: en }
  },
  lng: detectInitialLng(),
  fallbackLng: 'ja',
  supportedLngs: ['ja', 'en'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnNull: false
});

export const getLngFromPathname = detectLngFromPathname;
export default i18n;

